<template>
	<section>
		<!--工具条-->
		<div :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker type="date" v-model="filters.date" style="width: 100%;"></el-date-picker>
                </el-form-item>
				<el-form-item>
					<create-form-button  @select-type="bornForm" ></create-form-button>
					<download-form-button    @select-type="clickBtn" ></download-form-button>
				</el-form-item>
			</el-form>
		</div>

		<div id="formCon"  v-loading="loading"   element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
			<div id="title">
				<div class="title1"><span>{{projectName}}环境噪声状况分析报告</span></div>
				<div class="title2">
					<!-- <span class="span1">安徽科创中光科技有限公司</span> -->
					<span class="span2"> {{date2}}</span>
				</div>
				<div class="title3"><span> {{date1}}噪声日报</span></div>
			</div>
			<div id="con1">
				<div class="contitle">1.噪声概况</div>
				<p class="condes">
					<span>{{date1}}，{{projectName}}</span
					><span>{{totalData.allStr}}。</span>
				</p>
			</div>
			<div id="con2">
				<div class="contitle">2.噪声变化趋势</div>
				<div id="chart1" class="chartDiv1"></div>
				<div id="chart1img"></div>
			</div>
			<div id="con3">
				<div class="contitle">3.各点位值和环比情况</div>
				<div id="con3add"></div>
			</div>
			<div id="con4">
				<div class="contitle">4.各子站日均值排名情况</div>
				<div id="con4add"></div>
			</div>
			<div id="con6">
				<div class="contitle">5.各功能区达标率统计情况</div>
				<div id="con6add"></div>
				<div id="chart6" class="chartDiv1"></div>
				<div id="chart6img"></div>
			</div>
		</div>

	</section>
</template>

<script>
	import axios from 'axios';
	import util from '../../common/js/util'
	import * as echarts from "echarts";
	import {getProjects,bornDayForm } from '../../api/api';
	import {formatDateForm1,formatDateForm2,formatDate3} from '../../../static/fun.js';
	import {handleWindowPrint,drawEchartImg,initContent,deleteImg} from '../../../static/print.js';

	// import {htmlDocx} from '../../../static/html-docx.js';

	import CreateFormButton from '../../components/myButton/CreateFormButton.vue'
	import DownloadFormButton from '../../components/myButton/DownloadFormButton.vue'

	export default {
	components: { DownloadFormButton,CreateFormButton },
		data() {
			return {
				filters: {
					projectId: '',
					date:''
				},
				projects:[],
				projectName:'',

				totalData:{
					allStr:''
				},
				facList:[],
				facDic:[],

				date1:'',
				date2:'',
				picArr:[],
				loading:false,
				BiType:1,
				chooseNames:[],
				orderNum:5
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="pdf"){
					this.exportPDF();
				}else if(type=="word"){
					this.exportWord();
				}
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.projectName=this.projects[0].name;
					}
				});
			},
			bornForm(){
				this.loading=true;
				this.getProjectName();
				this.getDate();
				var param={
					projectId:this.filters.projectId,
					date:formatDate3(this.filters.date)
				}
				bornDayForm(param).then((res) => {
					this.loading=false;
					if(res.data.code!=200){
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
						return;
					}
					var resData=res.data.data;
					this.facList=resData.facList;
					this.facDic=resData.facDic;
					//部分数据赋值
					this.assignValue(resData);
					//渲染均值折线图
					this.initAvgChart(resData);
					//渲染环比情况
					this.initCirData(resData);
					//渲染排名情况
					this.initOrderData(resData);
					//渲染达标率统计情况
					this.initRateData(resData);
				});
			},
			initCirData(res){
				//先删除上次生成标签
				var body = document.getElementById('con3add');
				body.innerHTML='';
				this.facList.forEach(element => {
					if(element=="primarypollutant"||element=="aqi"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var lgd=name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var div = document.createElement('div');
						div.className="con3div";
						var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">序号</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td rowspan="2">功能区名称</td>'
									+'<td colspan="2">限值(dB)</td>'
									+'<td colspan="3">'+lgd+'</td>'
								+'</tr>'
								+'<tr>'
									+'<td>昼间</td>'
									+'<td>夜间</td>'
									+'<td>今天</td>'
									+'<td>昨天</td>'
									+'<td>环比率</td>'
								+'</tr>'
							+'</thead>'
							+'<tbody>';
							var i=1;
							var dataList=this.facDic[element].orderDataList;
							dataList.forEach(ele => {
								var mnInfo=res.devices[ele.mn];
								str+='<tr>'
									+'<td>'+i+'</td>'
									+'<td style="text-align:left">'+ele.name+'</td>'
									+'<td>'+mnInfo.functionalArea.name+'</td>'
									+'<td>'+mnInfo.functionalArea.day+'</td>'
									+'<td>'+mnInfo.functionalArea.night+'</td>'
									+'<td>'+(ele.today==null?'':ele.today)+'</td>'
									+'<td>'+(ele.yesterday==null?'':ele.yesterday)+'</td>'
									+'<td>'+(ele.rate==null?'':ele.rate)+'</td>'
									+'</tr>';
								i++;
							});
							str+='</tbody>';
						str+='</table>';
						str+='<p class="condes">'+this.date1+'，'+name+' 最低的是'+dataList[i-2].name+'，'+name+'最高的是'+dataList[0].name+'。</p>';
						div.innerHTML=str;
						body.appendChild(div);
					}
				})

				this.initChartdetail(res);
			},
			initRateData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con6add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var aData=[];
				var seriesData=[
					{
						type:'bar',
						name:'昼间',
						color:'#4DA2F7',
						data:[]
					},
					{
						type:'bar',
						name:'夜间',
						color:'#ED8A46',
						data:[]
					}
				];


				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">序号</td>'
							+'<td rowspan="2">功能区类型</td>'
							+'<td rowspan="2">个数</td>'
							+'<td colspan="2">昼间</td>'
							+'<td colspan="2">夜间</td>'
						+'</tr>'
						+'<tr>'
							+'<td>dB</td>'
							+'<td>%</td>'
							+'<td>dB</td>'
							+'<td>%</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.complianceRate;
					dataList.forEach(ele => {
						if(ele.count==0){
						}else{
							str+='<tr>'
								+'<td>'+i+'</td>'
								+'<td >'+ele.functionalAreaName+'</td>'
								+'<td>'+ele.count+'</td>'
								+'<td>'+ele.dayData+'</td>'
								+'<td>'+ele.dayRate+'</td>'
								+'<td>'+ele.nightData+'</td>'
								+'<td>'+ele.nightRate+'</td>'
								+'</tr>';
							i++;

							aData.push(ele.functionalAreaName);
							seriesData[0].data.push(ele.dayRate);
							seriesData[1].data.push(ele.nightRate);
						}
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
				this.drawRateDataChart(aData,seriesData);  
				this.picArr.push("chart6");
			},
			drawRateDataChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chart6'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"%</span><br>"
                            });
                            return result;
                        },
                    },
                    legend: {
                        data: ["昼间","夜间"],
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '6%',
                        bottom: '4%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        name:'功能区类别',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'达标率(%)',
                    },
                    series:seriesData
                 },true);
            },
			initOrderData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con4add');
				body.innerHTML='';
				this.facList.forEach(element => {
					var name=JSON.parse(sessionStorage.getItem(element)).name;
					var unit='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
					var div = document.createElement('div');
					div.className="con3div";

					var isExceedStr="";

					var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">排名</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td rowspan="2">功能区名称</td>';

					if(element=="n00001"){//不展示限值
						str+='<td >'+name+'</td>'
							+'</tr>'
							+'<tr>'
								+'<td>'+unit+'</td>'
							+'</tr>'
						+'</thead>'
						+'<tbody>';
						var i=1;
						var dataList=this.facDic[element].orderDataList;
						dataList.forEach(ele => {
							str+='<tr>'
								+'<td>'+i+'</td>'
								+'<td style="text-align:left">'+ele.name+'</td>'
								+'<td>'+ele.functionAreaName+'</td>'
								+'<td>'+(ele.today==null?'':ele.today)+'</td>'
								+'</tr>';
							i++;
						});
					}else{
						str+='<td >限值(dB)</td>'
								+'<td >'+name+'</td>'
							+'</tr>'
							+'<tr>'
								+'<td>'+(element=='n00004'?'昼间':'夜间')+'</td>'
								+'<td>'+unit+'</td>'
							+'</tr>'
						+'</thead>'
						+'<tbody>';
						var i=1;
						var dataList=this.facDic[element].orderDataList;
						dataList.forEach(ele => {
							str+='<tr>'
								+'<td>'+i+'</td>'
								+'<td style="text-align:left">'+ele.name+'</td>'
								+'<td>'+ele.functionAreaName+'</td>'
								+'<td>'+ele.limit+'</td>';
							if(ele.isExceed){
								str+='<td  class="red">'+(ele.today==null?'':ele.today)+'</td>';
								if(isExceedStr==""){
									isExceedStr=ele.name;
								}else{
									isExceedStr=isExceedStr+"，"+ele.name;
								}
							}else{
								str+='<td>'+(ele.today==null?'':ele.today)+'</td>'
							}
							str+='</tr>';
							i++;
						});
					}

					str+='</tbody>';
					str+='</table>';
					var minAndMax="";
					for(var i=0;i<this.orderNum;i++){
						minAndMax+=dataList[i].name;
						if(i!=this.orderNum-1){
							minAndMax+="，";
						}
					}
					str+='<p class="condes">'+this.date1+'，'+name+' 值最高的子站前'+this.orderNum+'名点位是：'+minAndMax+'。';
					if(isExceedStr!=""){
						str+=(element=='n00004'?'昼间':'夜间')+"超标点位："+isExceedStr+"。"
					}
					str+="</p>"
					div.innerHTML=str;
					body.appendChild(div);
				})
			},
			initAvgChart(resData){
				this.picArr=[];
				let aData=resData.timeList;
				var seriesData=[];
				var legendData=[];
				this.facList.forEach(element => {
					if(element=="aqi"||element=="primarypollutant"||element=="n00005"||element=="n00004"){
					}else{
						let facArr=this.facDic[element].avgList;
						var lgd=JSON.parse(sessionStorage.getItem(element)).name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var obj={
							name: lgd,
							type: 'line',
							data: facArr
						};
						seriesData.push(obj);
						legendData.push(lgd);
					}
				});
				this.drawLineChart(aData,seriesData,'chart1',legendData,'数据变化趋势图');  
				this.picArr.push("chart1");
			},
			initChartdetail(resData){
				//数据格式处理	
				let aData=resData.timeList;
				let mnstr=resData.devices;
				var i=0;
				this.chooseNames=[];
				var seriesDataAll=[];

				for (var j in mnstr) {//mn
					let deviceOne={};
					deviceOne.type='line';
					deviceOne.name=mnstr[j].name;
					deviceOne.nameTep=j;
					deviceOne.connectNulls=false;//null中断
					deviceOne.data=[];
					deviceOne.smooth=true;//光滑连接
					seriesDataAll.push(deviceOne);
					i++;
					this.chooseNames.push(mnstr[j].name);
				}

				var i=2;
				this.facList.forEach(fac => {
					if(fac=="primarypollutant"||fac=="n00005"||fac=="n00004"){
					}else{
						//获取数据
						var  seriesData= JSON.parse(JSON.stringify(seriesDataAll));

						for (let index = 0; index < seriesData.length; index++) {
							const element = seriesData[index];

							var data=resData.deviceHourDatas[element.nameTep];
							for (let j = 0; j < data.length; j++) {
								const dataOne = data[j];
								element.data.push(dataOne[fac])
							}

						}

						var div = document.createElement('div');
						div.id="chart"+i;
						div.className="chartDiv2 con3div";
						var body = document.getElementById('con3add');
						body.appendChild(div);
						this.drawLineChart(aData,seriesData,"chart"+i,this.chooseNames,JSON.parse(sessionStorage.getItem(fac)).name+'趋势图'); 
						var div2 = document.createElement('div');
						div2.id="chart"+i+"img";
						div2.className="con3div";
						body.appendChild(div2);
						this.picArr.push("chart"+i);
						i++;
					}
				})
			},
			assignValue(resData){
				this.orderNum=Math.min(Object.keys(resData.devices).length,5);
				this.totalData.allStr="";
				this.facList.forEach(element => {
					if(element=="primarypollutant"){
					}else if(element=="aqi"){
					}else{
						var fac=JSON.parse(sessionStorage.getItem(element));
						this.totalData.allStr+=fac.name+"值为"+this.facDic[element].today+fac.unit+",";
					}
				});
				if(this.totalData.allStr!=""){
					this.totalData.allStr=this.totalData.allStr.substring(0,this.totalData.allStr.length-1);
				}
			},
			drawLineChart:function(aData,seriesData,id,legendData,title) {
				var tit = ['','',''];
				var lgdStyle={
					data: legendTep,
					top:40,
					itemWidth: 10,  // 设置宽度
					itemHeight: 10, // 设置高度
					x:'right'
				};
				var topH=parseInt(seriesData.length/4)*20+60;
				if(topH>200){
					topH=80;
					lgdStyle={
						type: 'scroll', //分页类型
						data: legendTep,
						top:40,
						itemWidth: 10,  // 设置宽度
						itemHeight: 10, // 设置高度
						x:'right'
					};
				}
                var legendTep = tit.concat(legendData);
               	var chart = echarts.init(document.getElementById(id));
                chart.setOption({
					backgroundColor: '#fff',
                    title: {
                        text: title,
                        x:'left'
                    },
                    toolbox: {
                        show : true
                    },
                    legend: lgdStyle,
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:topH,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
						data:aData,
						"axisLabel":{
							interval: 0,
							rotate: 60,
                            margin:5,
						}
                    },
                    yAxis: {
						type: 'value',
						scale: true
                    },
                    series:seriesData
            	},true);
            },
			exportPDF(){
				var flag=handleWindowPrint('#formCon',this.picArr);
				if(!flag){
					this.$message({
						message: "导出日报出错，请重试",
						type: 'error'
					})
				}
			},
			exportWord(){
				if(drawEchartImg(this.picArr)){
					var content=initContent('#formCon');

					var converted = htmlDocx.asBlob(content);
					saveAs(converted, this.projectName+"_"+this.date1+'.docx');
					deleteImg(this.picArr);

					return;
					// var blob = new Blob([content], {
					// 	type:"application/msword;charset=utf-8"
					// }); 
					// var downloadElement = document.createElement("a");
					// var href = window.URL.createObjectURL(blob); //创建下载的链接
					// downloadElement.href = href;
					// downloadElement.download = this.projectName+"_"+this.date1+""; //下载后文件名
					// document.body.appendChild(downloadElement);
					// downloadElement.click(); //点击下载
					// document.body.removeChild(downloadElement); //下载完成移除元素
					// window.URL.revokeObjectURL(href); //释放掉blob对象
					// deleteImg(this.picArr);
					// return;
				}
			},
			getProjectName(){
				 this.projects.forEach(item => {
					if(this.filters.projectId==item.projectId){
						this.projectName=item.name;
						return;
					}
				});
			},
			getDate(){
				this.date1=formatDateForm1(this.filters.date);
				this.date2=formatDateForm2(this.filters.date);
			},
		},
		mounted() {
			this.getProjects();
			//time设为昨天
			var date = new Date();
			this.filters.date=date.getTime() - 3600 * 1000 * 24;
			this.getDate();
		}
	}

</script>

<style>
	@import 'form.css';
</style>


// WEBPACK FOOTER //
// day.vue?8ddc2ab2